import { render, staticRenderFns } from "./CustomerScreen.vue?vue&type=template&id=f9a9fb0e&scoped=true&"
import script from "./CustomerScreen.vue?vue&type=script&lang=ts&"
export * from "./CustomerScreen.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerScreen.vue?vue&type=style&index=0&id=f9a9fb0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a9fb0e",
  null
  
)

export default component.exports